export class Newsletter
{
    constructor(store)
    {
        this.store = store;
        this.NewsletterRand = document.querySelector('[data-s~="Newsletter:rand"]');
        this.NewsletterToken = document.querySelector('[data-s~="Newsletter:token"]');
        this.Agreement_1 = document.querySelector('[data-s~="Agreement:1"]');
        this.Agreement_2 = document.querySelector('[data-s~="Agreement:2"]');
        this.Agreement_3 = document.querySelector('[data-s~="Agreement:3"]');
        this.Email = document.querySelector('[data-s~="Email"]');
        this.NewsletterText = document.querySelector('[data-s~="Newsletter:text"]');
        this.Recaptcha = null;
        this.NewsletterFields = [
            this.Agreement_1,
            this.Agreement_2,
            this.Agreement_3,
            this.Email
        ];
    }

    prepareDataToSend(dataToCode)
    {
        let dataPart = [];
        for (let key in dataToCode) {
            dataPart.push(encodeURIComponent(key) + "=" + encodeURIComponent(dataToCode[key]));
        }
        return dataPart.join("&").replace(/%20/g, "+");
    }

    save()
    {
        const data = {
            rand: this.NewsletterRand.value,
            token: this.NewsletterToken.value,
            agree_1: this.Agreement_1.checked,
            agree_2: this.Agreement_2.checked,
            agree_3: this.Agreement_3.checked,
            email: this.Email.value,
            NewsletterForm_recaptcha_verification: this.Recaptcha.value
        };
        const dataToSend = this.prepareDataToSend(data);

        return fetch('/ajax/newsletter.php', {
            method: 'POST',
//            mode: 'cors',
            cache: 'no-cache',
//            credentials: 'same-origin',
            headers: {
//                'Content-Type': 'application/json'
                'Content-Type': 'application/x-www-form-urlencoded'
            },
//            redirect: 'follow',
            referrerPolicy: 'no-referrer',
            body: dataToSend
        }).then(response => {
            return response.json();
        });
    }

    subscribe()
    {
        this.save().then(response => {
            if (response !== 'token_error' && response !== 'recaptcha_error') {
                this.clearDisplayedErrors();
                this.clearInvalidAttributes();

                if (response[0] === '0') {
                    let errors = response[1];

                    for (let i in errors) {
                        let field = document.querySelector('[data-s~="' + i + '"]');
                        field.setAttribute('aria-invalid', 'true');
                        this.displayError(field, i, errors[i]);
                    }
                }
                else {
                    this.clearFields();
                    this.displayModal(response[1]);
                }
            }
            else {
                this.displayModal('Wystąpił nieoczekiwany błąd formularza. Proszę odświeżyć stronę i spróbować ponownie.');
            }
        });
    }

    displayError(fieldObject, fieldSelector, errorMessage)
    {
        let errorContainer = document.createElement('div');
        errorContainer.classList.add('newsletter-error');
        errorContainer.style.color = 'var(--color-rd)';
        errorContainer.dataset.d = 'ft-se=11rem lr-sg=1rem le-ht=1.2';
        errorContainer.dataset.c = 'co=yw';
        errorContainer.innerText = errorMessage;
        errorContainer.setAttribute('role', 'alert');

        if (fieldSelector === 'Email') {
            errorContainer.dataset.d += ' mn-tp=5px';
            fieldObject.closest('[data-s~="EmailField:container"]').append(errorContainer);
        }
        else {
            errorContainer.dataset.d += ' mn-lt=34px';
            fieldObject.closest('label').after(errorContainer);
        }
    }

    clearDisplayedErrors()
    {
        document.querySelectorAll('.newsletter-error').forEach(e => {
            e.remove();
        })
    }

    clearInvalidAttributes()
    {
        this.NewsletterFields.forEach(e => {
            e.setAttribute('aria-invalid', 'false');
        });
    }

    displayModal(text)
    {
        this.NewsletterText.innerText = text;
        this.store.service.Modal.target = "newsletter";
        this.store.service.Modal.show();
    }

    clearFields()
    {
        this.NewsletterFields.forEach(e => {
            e.value = null;
            e.checked = false;
        });
    }

    run()
    {
       document.addEventListener('NewsletterForm_recaptchaRefreshed', (e) => {
           this.Recaptcha = document.querySelector('#NewsletterForm_recaptcha_verification');
           this.subscribe();
       });
    }
}